import applyFilter from './applyFilter';
import getVariants from './getVariants';
import setBonusCurrency from './setBonusCurrency';
import resetGetVariants from './resetGetVariants';

const searchActions = {
  applyFilter,
  getVariants,
  setBonusCurrency,
  resetGetVariants,
};

export default searchActions;
